import styled from 'styled-components';
import { themes } from 'styles/themes/wikifactoryNew';

export const DiffViewportWrapper = styled.section`
  font-family: 'Helvetica Now Display';
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`;

export const ContentWrapper = styled.div`
  font-family: 'Helvetica Now Display';
  overflow-y: scroll;
  overflow-x: visible;
  position: relative;
  color: ${props => props.theme.color.wfBlack};
`;

export const SummaryWrapper = styled.div`
  font-family: 'Helvetica Now Display';
  display: grid;
  grid-template-columns: auto auto;
  border-bottom: 1px solid ${themes.color.wfGrey100};
`;

export const SummaryMeshWrapper = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  flex-direction: column;
  margin: 0.5rem 14px 0 0.5rem;
  padding: 0.1rem 0.25rem 0.5rem 0.25rem;
`;

export const SummaryLabel = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  padding-left: 0.25rem;

  color: ${props => props.theme.color.wfBlack};
  font-size: 0.875rem;
`;

export const GroupWrapper = styled.div`
  font-family: 'Helvetica Now Display';
  position: relative;
`;

export const ChangesetWrapper = styled.section`
 font-family: 'Helvetica Now Display';
  display: grid;
  grid-template-columns: 15px auto auto;
  grid-gap: 0;
  padding: 0.5rem 1rem;
  border-top: ${props =>
    props.expanded ? `1px solid ${themes.color.wfGrey100}` : 'none'}
  background: ${themes.color.wfWhite};
  font-size: 0.875rem;
  color: ${themes.color.wfBlack};

  &:hover {
    cursor: pointer;
    background: ${themes.color.wfGrey100};
  }
`;

export const GroupLabel = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 0.25rem;
  font-size: 0.875rem;
`;

export const TableWrapper = styled.div`
  font-family: 'Helvetica Now Display';
  display: ${props => (props.expanded ? 'block' : 'none')};
  position: relative;
  color: ${props => props.theme.color.wfBlack};
  font-size: 0.875rem;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  border-left: 1px solid ${props => props.theme.color.wfGrey200};
  border-right: 1px solid ${props => props.theme.color.wfGrey200};
`;

export const RowWrapper = styled.section`
  font-family: 'Helvetica Now Display';
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 0;
`;

export const RowSingleWrapper = styled.section`
  font-family: 'Helvetica Now Display';
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 0;
`;

export const FaceCell = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;

  ${props =>
    props.status == null
      ? `
    background-color: #ffffff;
    background-image: 
      repeating-linear-gradient(45deg, ${props.theme.color.wfGrey100} 25%, 
        transparent 25%, transparent 75%, ${props.theme.color.wfGrey100} 75%, 
        ${props.theme.color.wfGrey100}), 
      repeating-linear-gradient(45deg, ${props.theme.color.wfGrey100} 25%, 
        #ffffff 25%, #ffffff 75%, ${props.theme.color.wfGrey100} 75%, 
        ${props.theme.color.wfGrey100});
    background-position: 0 0, 7px 7px;
    background-size: 14px 14px;
  `
      : `
    background: ${`${props.color}55`};
    &:hover {
      cursor: pointer;
      
      box-shadow: inset 0px 1px 0 0 ${props.border},
                  inset 0px -1px 0 0 ${props.border};
    }
  `}

  ${props =>
    props.isSubGroupEnd &&
    `
    border-bottom: 1px solid ${props.theme.color.wfGrey200};
  `}

  ${props =>
    !props.isSingle &&
    `
    &:first-of-type {
      border-right: 1px solid ${props.theme.color.wfGrey200};
    }
  `}
  

  font-size: 0.875rem;
`;

export const StatusCell = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  width: 20px;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.theme.font.size.default};

  color: ${props =>
    props.status === ''
      ? props.theme.color.wfGrey800
      : props.theme.color.wfGrey900};

  ${props =>
    props.status &&
    `
      background: ${props.background ? `${props.background}` : 'transparent'};
      color: ${props.color ? props.color : 'transparent'};
  `}
`;

export const IconCell = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.25rem;

  svg * {
    stroke: ${props => props.stroke};
  }
`;

export const LabelCell = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const DataCell = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  margin-left: 10px;
  color: ${props => props.theme.color.wfGrey700};
`;

export const SummaryRow = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  justify-content: ${props => (props.atRight ? 'flex-end' : 'flex-start')};
  align-items: center;
  line-height: 14px;
`;

export const SummaryCell = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  align-items: center;
  padding: 4px 8px;

  background: ${props => (props.color ? `${props.color}` : 'transparent')};
  font-size: 0.875rem;

  color: ${props => props.theme.color.wfBlack};
  border: 1px solid ${props => props.theme.color.wfWhite};
  border-radius: 4px;

  border-color: ${props =>
    props.border ? `${props.border}` : props.theme.color.wfGrey400};
`;

export const PhysTable = styled.section`
  font-family: 'Helvetica Now Display';
  margin: 12px 0.5rem 0 0.5rem;
  padding: 0.5rem 0 0.25rem 0.5rem;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  color: ${props => props.theme.color.wfBlack};
  background: #eaeef280;
`;

export const PhysRowWrapper = styled.section`
  font-family: 'Helvetica Now Display';
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0;
  color: ${themes.color.wfBlack};
  margin: 4px 0px;
  font-size: 0.875rem;
`;

const getColor = props => {
  if (props.header || props.file) {
    return themes.color.wfBlack;
  }

  if (props.change && props.change > 0) {
    return themes.color.wfGreen;
  }

  if (props.change && props.change < 0) {
    return themes.color.wfRed;
  }

  return themes.color.wfBlack;
};

export const PhysLabelCell = styled.div`
  font-family: 'Helvetica Now Display';
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0;
  font-size: 0.875rem;

  color: ${props => getColor(props)};
`;
